import { render } from "./ListeTagPage.vue?vue&type=template&id=2ff99d1c&ts=true"
import script from "./ListeTagPage.vue?vue&type=script&lang=ts"
export * from "./ListeTagPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__